import { StepperFormStep } from '@sh4res/bo-common/components';
import {
  ArbitrageFormData,
  sumArbitrageRows,
} from '@sh4res/bo-common/components/B2bArbitrage/buildArbitrageBody';
import { ConfirmationStep } from '@sh4res/bo-common/components/B2bArbitrage/steps/ConfirmationStep';
import { FundsStep } from '@sh4res/bo-common/components/B2bArbitrage/steps/FundsStep';

export const arbitrageSteps: StepperFormStep[] = [
  {
    label: 'resources.bo_common.b2b.arbitrage_create.steps.funds',
    content: <FundsStep />,
  },
  {
    label: 'resources.bo_common.b2b.arbitrage_create.steps.confirmation',
    content: <ConfirmationStep />,
    saveDisabled: (values) => {
      const { sources, targets, reason, confirm_accuracy } = values as ArbitrageFormData;
      const totalSold = sumArbitrageRows(sources);
      return (
        totalSold === 0 ||
        totalSold !== sumArbitrageRows(targets) ||
        !reason?.trim() ||
        !confirm_accuracy?.includes('yes')
      );
    },
  },
];
